import "./Reward.css";

import ProductNavbar from "../Navbar/ProductNavbar";
import { useEffect } from "react";
import {
  FaChartLine,
  FaLeaf,
  FaCloud,
  FaShieldAlt,
  FaDatabase,
  FaMapMarkedAlt,
  FaFileAlt,
  FaGlobeAsia,
  FaProjectDiagram,
  FaCalculator,
  FaChartPie,
  FaUsers,
  FaClipboardCheck,
  FaChartBar,
  FaCheckCircle,
  FaArrowRight,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaCloudSun,
  FaSeedling,
  FaWind,
  FaCloudRain,
  FaSyncAlt,
  FaFilter,
  FaHistory,
} from "react-icons/fa";

import heroVideo from "../../assets/REWARD BG.mp4";

const Reward = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
  const features = [
    {
      icon: <FaDatabase />,
      title: "Centralized Data Collection",
      desc: "Collect APSM, AWS and NRM data from multiple locations in one platform.",
    },
    {
      icon: <FaCalculator />,
      title: "Automatic Calculations",
      desc: "Automatically calculate watershed statistics with zero manual effort.",
    },
    {
      icon: <FaChartPie />,
      title: "Interactive Dashboard",
      desc: "Monitor watershed performance through beautiful visual dashboards.",
    },
    {
      icon: <FaFileAlt />,
      title: "Report Generation",
      desc: "Generate project reports instantly in multiple formats.",
    },
    {
      icon: <FaChartBar />,
      title: "Analytics",
      desc: "Advanced analytical reports for better project monitoring.",
    },
    {
      icon: <FaCloud />,
      title: "Cloud Platform",
      desc: "Access data securely from anywhere.",
    },
  ];

  const analyticsModules = [
    {
      icon: <FaCloudSun />,
      title: "Weather Monitoring",
      desc: "Monitor temperature, humidity, wind speed, wind direction, air pressure, solar radiation and net radiation with live sensor updates every 15 minutes.",
    },
    {
      icon: <FaSeedling />,
      title: "Soil Monitoring",
      desc: "Track soil moisture, temperature and electrical conductivity at multiple depths including 15cm, 30cm, 45cm, 60cm, 80cm, 90cm and 120cm.",
    },
    {
      icon: <FaWind />,
      title: "Air Monitoring",
      desc: "Observe atmospheric conditions across multiple heights (2m, 4m and 6m) for better environmental analysis.",
    },
    {
      icon: <FaCloudRain />,
      title: "Rainfall Analytics",
      desc: "View actual rainfall, event-wise rainfall and accumulated rainfall with automatic data collection.",
    },
    {
      icon: <FaChartLine />,
      title: "Interactive Charts",
      desc: "Visualize live data using dynamic line charts, bar charts and trend graphs that refresh automatically.",
    },
    {
      icon: <FaSyncAlt />,
      title: "Real-Time Updates",
      desc: "Sensor values are synchronized automatically every 15 minutes without refreshing the application.",
    },
    {
      icon: <FaFilter />,
      title: "Advanced Filters",
      desc: "Quickly filter stations, parameters, soil depths, date ranges and multiple environmental variables.",
    },
    {
      icon: <FaHistory />,
      title: "Historical Analysis",
      desc: "Compare hourly, daily, weekly and monthly environmental trends using historical sensor data.",
    },
  ];

  const modules = [
    {
      icon: <FaLeaf />,
      title: "Watershed Management",
      desc: "Manage complete watershed project information.",
    },

    {
      icon: <FaProjectDiagram />,
      title: "Project Tracking",
      desc: "Track project progress from planning to completion.",
    },

    {
      icon: <FaDatabase />,
      title: "Data Management",
      desc: "Store, organize and validate project datasets.",
    },

    {
      icon: <FaChartLine />,
      title: "Performance Monitoring",
      desc: "Monitor KPIs through live dashboards.",
    },

    {
      icon: <FaClipboardCheck />,
      title: "Survey Management",
      desc: "Manage field surveys digitally.",
    },

    {
      icon: <FaMapMarkedAlt />,
      title: "GIS Module",
      desc: "View geographical data with mapping tools.",
    },

    {
      icon: <FaChartPie />,
      title: "Reports",
      desc: "Generate statistical and graphical reports.",
    },

    {
      icon: <FaUsers />,
      title: "User Administration",
      desc: "Manage users and permissions.",
    },

    {
      icon: <FaShieldAlt />,
      title: "Security",
      desc: "Enterprise grade authentication and authorization.",
    },
  ];

  const benefits = [
    {
      icon: <FaCheckCircle />,
      title: "100% Paperless",
      desc: "Digitize the complete watershed workflow.",
    },

    {
      icon: <FaChartBar />,
      title: "Better Decisions",
      desc: "Real-time insights improve planning.",
    },

    {
      icon: <FaCloud />,
      title: "Anywhere Access",
      desc: "Cloud-based secure platform.",
    },

    {
      icon: <FaDatabase />,
      title: "Accurate Data",
      desc: "Maintain consistent project information.",
    },

    {
      icon: <FaShieldAlt />,
      title: "Highly Secure",
      desc: "JWT Authentication & Role Permissions.",
    },

    {
      icon: <FaGlobeAsia />,
      title: "Scalable",
      desc: "Supports district, state and national level projects.",
    },
  ];
  const workflow = [
    "Collect Field Data",

    "Upload Field Data",

    "Validate Records",

    "Automatic Calculations",

    "Dashboard Visualization",

    "Generate Reports",

    "Decision Making",
  ];
  const reports = [
    "Watershed Progress Report",

    "Project Status Report",

    "Village Report",

    "Survey Report",

    "Rainfall Report",

    "Financial Report",

    "Performance Dashboard",
  ];
  return (
    <>
      <ProductNavbar />
      <div className="reward-page">
        <section className="reward-hero">
          {/* HTML5 Background Video */}
          <video className="hero-video" autoPlay loop muted playsInline>
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="overlay"></div>

          <div className="hero-content">
            <h1>REWARD</h1>
            <p style={{ whiteSpace: "nowrap" }}>
              (Rejuvenating Watersheds for Agricultural Resilience through
              Innovative Development Programme.)
            </p>
            <p>
              An intelligent Watershed Analytics Platform designed for APSM, AWS
              and NRM projects that simplifies project management, automates
              calculations and delivers powerful visual analytics.
            </p>
            <button
              className="demo-btn"
              onClick={() => {
                document.getElementById("request-demo")?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Request Demo
            </button>
          </div>
        </section>
        <section className="section">
          <h2>About Reward</h2>

          <p className="section-description">
            Reward is an enterprise watershed analytics platform built for
            government departments and organizations to efficiently manage,
            monitor and analyze watershed projects through automated
            calculations, dashboards and GIS visualization.
          </p>
        </section>
        {/* KEY FEATURES */}
        <section className="section">
          {/* <div className="section-badge">CAPABILITIES</div> */}
          <h2>Key Features</h2>

          <div className="feature-grid">
            {features.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
        {/* Analytics & Monitoring */}
        {/* Analytics & Monitoring */}
        <section className="section analytics-section">
          <div
            className="section-badge"
            style={{ background: "var(--secondary)", color: "#fff" }}
          >
            LIVE TELEMETRY ENGINE
          </div>
          <h2>Environmental Analytics & Monitoring</h2>

          <p className="section-description">
            REWARD continuously collects environmental sensor data, processes it
            in real time and provides interactive visualizations for better
            decision making.
          </p>

          <div className="analytics-grid">
            {analyticsModules.map((item, index) => (
              <div className="analytics-card" key={index}>
                <div className="analytics-icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="section light-bg">
          <h2>Core Modules</h2>

          <div className="module-grid">
            {modules.map((item, index) => (
              <div className="module-card" key={index}>
                <div className="icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section">
          <h2>Platform Benefits</h2>

          <div className="benefit-grid">
            {benefits.map((item, index) => (
              <div className="benefit-card" key={index}>
                <div className="icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="section light-bg">
          <h2>How Reward Works</h2>

          <div className="workflow">
            {workflow.map((step, index) => (
              <div className="workflow-step" key={index}>
                <div className="circle">{index + 1}</div>

                <h4>{step}</h4>

                {index !== workflow.length - 1 && (
                  <div className="arrow">
                    <FaArrowRight />
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
        <section className="section">
          <h2>Reports & Dashboards</h2>

          <div className="report-grid">
            {reports.map((report, index) => (
              <div className="report-card" key={index}>
                <FaCheckCircle />

                <span>{report}</span>
              </div>
            ))}
          </div>
        </section>
        <section className="section">
          <h2>Security & Reliability</h2>

          <div className="security-grid">
            <div className="security-card">
              <FaShieldAlt />

              <h3>JWT Authentication</h3>

              <p>Secure login using JSON Web Tokens.</p>
            </div>

            <div className="security-card">
              <FaUsers />

              <h3>Role Based Access</h3>

              <p>Manage permissions securely.</p>
            </div>

            <div className="security-card">
              <FaCloud />

              <h3>Cloud Deployment</h3>

              <p>Reliable cloud infrastructure with high availability.</p>
            </div>
          </div>
        </section>
        <section className="section">
          <h2>Why Choose Reward?</h2>

          <div className="why-grid">
            <div>✔ Automated Watershed Calculations</div>

            <div>✔ Interactive GIS Maps</div>

            <div>✔ Live Dashboards</div>

            <div>✔ Advanced Analytics</div>

            <div>✔ Secure Cloud Platform</div>

            <div>✔ Enterprise Ready</div>

            <div>✔ Easy Report Generation</div>

            <div>✔ Real-Time Monitoring</div>

            <div>✔ Government Project Support</div>
          </div>
        </section>
        <section id="request-demo" className="cta">
          <h2>Ready to Modernize Watershed Management?</h2>

          <p>
            Discover how Reward transforms watershed projects through
            automation, analytics and intelligent reporting.
          </p>

          <button className="contact-btn">Contact Us</button>

          <div className="contact-info">
            <div className="info-box">
              <FaEnvelope />

              <h4>Email</h4>

              <a href="mailto:contactus@belageri.com">contactus@belageri.com</a>
            </div>

            <div className="info-box">
              <FaPhoneAlt />

              <h4>Phone</h4>

              <a href="tel:+919449974910">+91 9449974910</a>
            </div>

            <div className="info-box">
              <FaMapMarkerAlt />

              <h4>Office</h4>

              <p>Belageri Technologies Pvt Ltd</p>
            </div>
          </div>
        </section>
        <footer className="reward-footer">
          <h3>Reward</h3>

          <p>
            Empowering Watershed Projects with Data Analytics, GIS Intelligence
            and Automated Reporting.
          </p>

          <p>© 2025 Reward. All Rights Reserved.</p>
        </footer>
      </div>
    </>
  );
};

export default Reward;
